import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Heritage from './components/Heritage';
import Process from './components/Process';
import Benefits from './components/Benefits';
import Story from './components/Story';
import CTA from './components/CTA';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

export default function Home() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative">
      <Navbar isScrolled={isScrolled} />
      <Hero />
      <Heritage />
      <Process />
      <Benefits />
      <Story />
      <CTA />
      <Footer />
    </div>
  );
}
